module.exports = __webpack_public_path__ + "static/media/ProductsIcon.76f83b88.svg";